import React from 'react';

/** Paths from Android `ic_withdraw_balance.xml` (viewport 64) */
export function WithdrawIcon({ size = 26, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M32,22m-4.25,0a4.25,4.25 0,1 1,8.5 0a4.25,4.25 0,1 1,-8.5 0"
      />
      <path
        fill="currentColor"
        d="m55,3.25h-46c-1.517,0 -2.75,1.233 -2.75,2.75v8c0,1.517 1.233,2.75 2.75,2.75h7.75v-6h-4.75c-0.414,0 -0.75,-0.336 -0.75,-0.75s0.336,-0.75 0.75,-0.75h40c0.414,0 0.75,0.336 0.75,0.75s-0.336,0.75 -0.75,0.75h-4.75v6h7.75c1.517,0 2.75,-1.233 2.75,-2.75v-8c0,-1.517 -1.233,-2.75 -2.75,-2.75z"
      />
      <path fill="currentColor" d="m45.75,34.75v2.52l-2.07,-2.39c0.43,-0.09 0.87,-0.13 1.32,-0.13z" />
      <path
        fill="currentColor"
        d="m19,34.75h-0.75v4.25c0,2.067 1.683,3.75 3.75,3.75h4.25v-0.75c0,-3.998 -3.252,-7.25 -7.25,-7.25z"
      />
      <path
        fill="currentColor"
        d="m18.25,10.75v22.5h0.75c4.83,0 8.75,3.92 8.75,8.75v0.75h6.42l-2.54,-3.27c-1.01,-1.31 -1.45,-2.93 -1.22,-4.56 0.23,-1.64 1.09,-3.08 2.42,-4.05 1.04,-0.77 2.28,-1.17 3.58,-1.17 1.77,0 3.45,0.76 4.6,2.09l1.56,1.8c0.77,-0.22 1.59,-0.34 2.43,-0.34h0.75v-22.5zM32,27.75c-3.17,0 -5.75,-2.58 -5.75,-5.75s2.58,-5.75 5.75,-5.75 5.75,2.58 5.75,5.75 -2.58,5.75 -5.75,5.75z"
      />
      <path
        fill="currentColor"
        d="M40,52.25L54,52.25A2.75,2.75 0,0 1,56.75 55L56.75,58A2.75,2.75 0,0 1,54 60.75L40,60.75A2.75,2.75 0,0 1,37.25 58L37.25,55A2.75,2.75 0,0 1,40 52.25z"
      />
      <path
        fill="currentColor"
        d="m38.174,51.179c0.555,-0.267 1.17,-0.429 1.826,-0.429h14c0.425,0 0.828,0.082 1.215,0.198 1.077,-3.237 2.255,-9.792 0.481,-14.227 -1.34,-3.35 -5.589,-8.297 -8.446,-11.398v15.969l-7.378,-8.524c-1.548,-1.79 -4.25,-2.092 -6.156,-0.693 -1.001,0.735 -1.648,1.818 -1.818,3.049 -0.172,1.231 0.154,2.451 0.918,3.434l4.358,5.603c-0.291,1.132 -0.885,4.415 1,7.019z"
      />
    </svg>
  );
}

/** Paths from Android `ic_split_balance.xml` (viewport 512) */
export function PoolSplitIcon({ size = 26, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className={className}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M394.56,180.99H330.2c19.8,19.37 31.8,46.14 31.8,75s-12,55.63 -31.8,75h64.36c4.53,-12.77 14.66,-22.91 27.44,-27.44V208.43C409.23,203.9 399.09,193.77 394.56,180.99z"
      />
      <path fill="currentColor" d="M302,196.03v119.92c18.5,-13.92 30,-35.97 30,-59.96C332,232.01 320.5,209.95 302,196.03z" />
      <path
        fill="currentColor"
        d="M497,90.99h-27.86H302v60h105c8.29,0 15,6.71 15,15c0,8.28 6.72,15 15,15c8.29,0 15,6.71 15,15v120c0,8.29 -6.71,15 -15,15c-8.28,0 -15,6.72 -15,15c0,8.29 -6.71,15 -15,15H302v60h167.14H497c8.29,0 15,-6.71 15,-15v-300C512,97.7 505.29,90.99 497,90.99z"
      />
      <path fill="currentColor" d="M240,60.99h32v390h-32z" />
      <path fill="currentColor" d="M180,255.99c0,23.98 11.5,46.04 30,59.96V196.03C191.5,209.95 180,232.01 180,255.99z" />
      <path
        fill="currentColor"
        d="M181.8,180.99h-64.36c-4.53,12.77 -14.66,22.91 -27.44,27.44v95.13c12.77,4.53 22.91,14.66 27.44,27.44H181.8c-19.8,-19.37 -31.8,-46.14 -31.8,-75S162,200.36 181.8,180.99z"
      />
      <path
        fill="currentColor"
        d="M75,180.99c8.28,0 15,-6.72 15,-15c0,-8.29 6.71,-15 15,-15h105v-60H42.86H15c-8.29,0 -15,6.71 -15,15v300c0,8.29 6.71,15 15,15h27.86H210v-60H105c-8.29,0 -15,-6.71 -15,-15c0,-8.28 -6.72,-15 -15,-15c-8.29,0 -15,-6.71 -15,-15v-120C60,187.7 66.71,180.99 75,180.99z"
      />
      <path
        fill="currentColor"
        d="M53.66,450.99l7.23,20.08c2.2,6.11 7.95,9.92 14.11,9.92c1.57,0 3.15,-0.25 4.72,-0.76l88.37,-29.24H53.66z"
      />
      <path
        fill="currentColor"
        d="M343.91,450.99l88.37,29.24c1.57,0.51 3.15,0.76 4.72,0.76c6.15,0 11.91,-3.82 14.11,-9.92l7.23,-20.08H343.91z"
      />
      <path
        fill="currentColor"
        d="M79.72,31.76c-7.7,-2.52 -16.07,1.51 -18.82,9.15l-7.23,20.08h114.43L79.72,31.76z"
      />
      <path
        fill="currentColor"
        d="M451.11,40.91c-2.75,-7.66 -11.07,-11.66 -18.82,-9.15l-88.37,29.24h114.43L451.11,40.91z"
      />
    </svg>
  );
}

export function ChevronRightSmall() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" className="tx-chevron">
      <path fill="currentColor" d="M9 6l6 6-6 6V6z" />
    </svg>
  );
}
